module.exports = __webpack_public_path__ + "img/contact.f2c5bc9d.svg";